export default {
  allReviewCriterias: [],
}
